import React, { useEffect, useState } from "react";
import { useWorkspaceList } from "../hooks/ui";
import Spinner from "../components/Spinner";
import AddColumnWorkspaceListBig from "../components/AddColumn/big/AddColumnWorkspaceListBig";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store/store";
import logger from "../lib/logger";
import { MondayApiQueryInstance } from "../services/monday/monday-service-ts";
import useBoardAndItems from "../hooks/context/useBoardAndItems";
import useUser from "../hooks/context/userHook";
import ErrorPage from "../components/errorPage";
import PageLoader from "../components/PageLoader";
import { useCheckUserOnboarding } from "../hooks/api/useCheckUserOnboarding";

const AddColumn = () => {
  const { workspaceListdata, isLoading } = useWorkspaceList(true);
  const { columnType, columnId } = useSelector((state: RootState) => state.monday);
  const { userId } = useUser();
  const { currentBoard } = useBoardAndItems();
  const [columnTitle, setColumnTitle] = useState("");

  const { isAuthorized, error } = useCheckUserOnboarding(userId);

  useEffect(() => {
    const fetchColumnTitle = async (currentBoard: number, columnId: string) => {
      try {
        const response = await MondayApiQueryInstance.getColumnDetailsByColumnId(currentBoard, [columnId]);

        if (response && response.length > 0) {
          setColumnTitle(response[0]?.title);
        }
      } catch (error: any) {
        logger.error("Error fetching column title:", error);
        throw error;
      }
    };

    if (columnId && currentBoard) {
      fetchColumnTitle(currentBoard, columnId);
    }
  }, [columnId, currentBoard]);

  if (isAuthorized) {
    <div className="App">
      <PageLoader />
    </div>;
  }

  if (error) {
    return <ErrorPage />;
  }

  return (
    <div className="w-full h-screen">
      {isLoading ? (
        <div className={"overflow-x-hidden overflow-y-scroll px-2 pb-1 w-full h-screen bg-white rounded shadow-2xl"}>
          <div className="flex gap-2 items-center pt-4 pb-4">
            <Spinner /> Getting your workspaces
          </div>
        </div>
      ) : (
        <AddColumnWorkspaceListBig
          data={workspaceListdata!}
          originColumnTitle={columnTitle}
          originColumnType={columnType!}
          originColumnId={columnId!}
          originBoard={currentBoard!.toString()}
        />
      )}
    </div>
  );
};

export default AddColumn;
